"use client";
import React, { useRef } from "react";
import { useScroll, useTransform, motion } from 'framer-motion';
import { useFollowPointer } from "hook/useFollowPointer";

export default function ImageMac({ image = "" }: { image: any }) {

    const container = useRef(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start end", "end start"]
    })

    const height = useTransform(scrollYProgress, [0, 0.9], [50, 0])

    const ref = useRef<HTMLDivElement | null>(null);
    const { x, y } = useFollowPointer(ref);

    return (
        <>
            <div ref={container} >
                <div className='bg-[#FFA98F] lg:w-screen py-12 md:py-24 4xl:py-36 flex flex-col items-center justify-center overflow-hidden'>
                    <motion.div ref={ref} className={`hidden lg:block z-40 relative w-fit justify-center items-center`} style={{ x, y }}>
                        <p className='text-lg 4xl:text-xl bg-lemone px-3'>Hover Mac</p>
                    </motion.div>
                    <div className="w-[320px] md:w-[640px] lg:w-[800px] xl:w-[900px] 2xl:w-[1300px] 4xl:w-[1800px] flex flex-col justify-center relative">
                        <div className="relative w-[280px] md:w-[520px] lg:w-[640px] xl:w-[720px] 2xl:w-[1110px] 4xl:w-[1400px] mx-auto rounded-t-[8px] md:rounded-t-[12px]
                    xl:rounded-t-[16px] 2xl:rounded-t-[18px] flex flex-col p-[1px] md:p-[2px] xl:p-[4px] 2xl:p-1 !pb-0"
                            style={{ background: "linear-gradient(180deg, rgba(219,219,222,1) 0%, rgba(145,142,144,1) 90%)" }}>
                            <div className="w-full h-full rounded-t-[6px] md:rounded-t-[9px]
                        xl:rounded-t-[12px] 2xl:rounded-t-[17px] bg-[#010101] p-[4px] md:p-[8px] lg:p-[12px] 2xl:p-[16px] 4xl:p-[18px]">
                                <div className="bg-[#010101] w-full h-full aspect-16/9 rounded-t-[4px] 2xl:rounded-t-[8px] relative overflow-hidden">
                                    <motion.img className="w-full absolute z-30" src={`/assets/images/portfolio/mac/${image}`} alt=""
                                        initial={{ opacity: 1, bottom: "unset", top: 0 }}
                                        whileHover={{
                                            opacity: 1,
                                            top: "unset",
                                            bottom: 0,
                                            transition: { duration: 15 },
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="h-[8px] md:h-[12px] lg:h-[16px] 2xl:h-[30px] w-full bg-[#222222]"></div>
                        </div>
                        <img className="w-full h-auto" src="/pettern/mac.png" alt="" />
                    </div>
                </div>

                <motion.div style={{ height }} className="relative bg-[#FFA98F]">
                    <div className="h-[1550%] w-[120%] left-[-10%] bg-[#FFA98F] overflow-hidden z-10 absolute rounded-b-[50%]"
                        style={{ boxShadow: '0px 60px 50px rgba(0, 0, 0, 0.748)' }}
                    >
                        <h2 className="text-center text-[5.5rem] lg:text-[8rem] font-bold text-smoke">
                            Next<span className="text-[2.25rem] text-smoke  ">Case</span>
                        </h2>
                    </div>
                </motion.div>
            </div>
        </>
    );
}
